import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { VideoShowcase } from "@/components/VideoShowcase";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { JsonLd } from "@/components/JsonLd";
import { services } from "@/data/company";

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "NetForge",
  url: "https://netforgesols.com",
  logo: "https://netforgesols.com/logo-footer.png",
  description:
    "NetForge provides end-to-end IT and marketing solutions: web & app development, custom CRM systems, cloud & IT hardware, digital marketing, SEO, branding and graphic design.",
  slogan: "Build. Connect. Grow.",
  email: "asith.dasanayake@netforgesols.com",
  telephone: "+94 70 773 3647",
  address: {
    "@type": "PostalAddress",
    addressCountry: "LK",
    addressRegion: "Sri Lanka",
  },
  makesOffer: services.map((s) => ({
    "@type": "Offer",
    itemOffered: { "@type": "Service", name: s.title, description: s.desc },
  })),
};

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[#0a0f1e] min-h-screen">
      <Seo
        title="NetForge — IT & Marketing Solutions | Build. Connect. Grow."
        description="NetForge delivers end-to-end IT and marketing solutions — web & app development, custom CRM systems, cloud & IT hardware, digital marketing, SEO, branding and graphic design."
        path="/"
      />
      <JsonLd id="organization" data={orgSchema} />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <VideoShowcase />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
